// src/components/NotFound.js
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
  <div style={{ textAlign: "center", marginTop: "4rem" }}>
    <h2>404 – Page Not Found</h2>
    <p>The page you’re looking for doesn’t exist.</p>
    <Link to="/">Go back to Login</Link>
  </div>
);

export default NotFound;
